let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kXWHC")).then(() => parcelRequire('cHiFW'));